import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import LeftPanel from './include/MasterLeftPanel';
import { useNavigate } from 'react-router-dom';
function SystemSettingDashBoard() {
    let navigate = useNavigate();
    const items = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
      }, []);
  return (
    <>
        <LeftPanel/>
        <main className='home-section'>
        <Header/>
        <div className="overlay"></div>
        <div className='col-12 mt-4'><h2>System Setting Dashboard</h2></div>
        <div className='container-fulid'>
                <div className='row'>
                    {items.usertype =='AD' &&
                    <div className="col-md-6 col-12">
                        <div className="card h-100">
                            <div className="bg-holder bg-card"></div>
                            <div className="card-header z-1">
                                <h5 className="text-primary">Price Master! </h5>
                                <h6 className="text-600">Here are some quick links for you to start </h6>
                            </div>
                            <div className="card-body z-1">
                                <div className="row g-2">
                                    <div className="col-sm-6 col-md-6">
                                        <div className="d-flex position-relative">
                                            <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-dollar'></i></div>
                                            <div className="flex-1"><a className="stretched-link text-800" href="/ServiceList/All">
                                                <h6 className="mb-0">All Services</h6>
                                            </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6">
                                        <div className="d-flex position-relative">
                                            <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-dollar'></i></div>
                                            <div className="flex-1"><a className="stretched-link text-800" href="/ServiceList/Domestic">
                                                <h6 className="mb-0">Domstic Services</h6>
                                            </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-6">
                                        <div className="d-flex position-relative">
                                            <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-dollar'></i></div>
                                            <div className="flex-1"><a className="stretched-link text-800" href="/ServiceList/International">
                                                <h6 className="mb-0">International Services</h6>
                                            </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {items.usertype =='AD' &&
                    <div className="col-md-6 col-12">
                        <div className="card h-100">
                            <div className="bg-holder bg-card"></div>
                            <div className="card-header z-1">
                            <h5 className="text-primary">Shipping Zones Management! </h5>
                            <h6 className="text-600">Here are some quick links for you to start </h6>
                            </div>
                            <div className="card-body z-1">
                            <div className="row g-2">
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-alt'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/zoneList/All">
                                            <h6 className="mb-0">All Zones</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-alt'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/zoneList/Domestic">
                                            <h6 className="mb-0">Domestic Zones Cities</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-alt'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/zoneList/International">
                                            <h6 className="mb-0">International Zones Countries</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-alt'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/ZoneSetDomestic">
                                            <h6 className="mb-0">Set Domestic Country Zones</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-alt'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/ZoneSetInternational">
                                            <h6 className="mb-0">Set International City Zones</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    }
                    {items.usertype =='AD' || items.usertype =='M' &&
                    <div className="col-md-6 col-12 pt-3">
                        <div className="card h-100">
                            <div className="bg-holder bg-card"></div>
                            <div className="card-header z-1">
                            <h5 className="text-primary">Shipping Routes Management! </h5>
                            <h6 className="text-600">Here are some quick links for you to start </h6>
                            </div>
                            <div className="card-body z-1">
                            <div className="row g-2">
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-flag'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/Routelist/All">
                                            <h6 className="mb-0">All Routes</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-flag'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/Routelist/Domestic">
                                            <h6 className="mb-0">All Domestic Routes</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-flag'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/Routelist/International">
                                            <h6 className="mb-0">All International Routes</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-flag'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/RouteAdd">
                                            <h6 className="mb-0">Add New Route</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    }
                    {items.usertype =='AD' &&
                    <div className="col-md-6 col-12 pt-3">
                        <div className="card h-100">
                            <div className="bg-holder bg-card"></div>
                            <div className="card-header z-1">
                            <h5 className="text-primary">Location Management! </h5>
                            <h6 className="text-600">Here are some quick links for you to start </h6>
                            </div>
                            <div className="card-body z-1">
                            <div className="row g-2">
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/Countrylist">
                                            <h6 className="mb-0">All Countries</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/CountryAdd">
                                            <h6 className="mb-0">Add Country</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    }
                    {items.usertype =='AD' &&
                    <div className="col-md-6 col-12 pt-3">
                        <div className="card h-100">
                            <div className="bg-holder bg-card"></div>
                            <div className="card-header z-1">
                            <h5 className="text-primary">Pincode Management! </h5>
                            <h6 className="text-600">Here are some quick links for you to start </h6>
                            </div>
                            <div className="card-body z-1">
                            <div className="row g-2">
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-pin'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/Pincodelist">
                                            <h6 className="mb-0">All Pincodes</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bx-map-pin'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/PincodeAdd">
                                            <h6 className="mb-0">Import Pincodes</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    }
                    {items.usertype =='AD' &&
                    <div className="col-md-6 col-12 pt-3">
                        <div className="card h-100">
                            <div className="bg-holder bg-card"></div>
                            <div className="card-header z-1">
                            <h5 className="text-primary">Settings! </h5>
                            <h6 className="text-600">Here are some quick links for you to start </h6>
                            </div>
                            <div className="card-body z-1">
                            <div className="row g-2">
                                <div className="col-sm-6 col-md-6">
                                    <div className="d-flex position-relative">
                                        <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2"><i className='bx bxs-cog'></i></div>
                                        <div className="flex-1"><a className="stretched-link text-800" href="/Settings">
                                            <h6 className="mb-0">General Settings</h6>
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <Footer/>
            </main>
    </>
  );
}

export default SystemSettingDashBoard;